const firebaseConfig = {
    apiKey: "AIzaSyCXzXsVW9vTp8ySKxvNiBhirTwFE5NzK30",
    authDomain: "day-care05.firebaseapp.com",
    projectId: "day-care05",
    storageBucket: "day-care05.appspot.com",
    messagingSenderId: "37416338681",
    appId: "1:37416338681:web:10d5495bad36373f6e4e28"
  };
  export default firebaseConfig;